/* eslint-disable */
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// The values in this file are generated in CodeBuild
// You can also create a .env.local file during development
// https://create-react-app.dev/docs/adding-custom-environment-variables/

import { Auth } from 'aws-amplify';

const getIdToken = async () => ({
  Authorization: (await Auth.currentSession()).getIdToken().getJwtToken(),
});

const {
  REACT_APP_USER_POOL_ID,
  REACT_APP_USER_POOL_CLIENT_ID,
  REACT_APP_IDENTITY_POOL_ID,
  REACT_APP_APPSYNC_GRAPHQL_URL,
  REACT_APP_AWS_REGION,
  REACT_APP_CLOUDFRONT_DOMAIN,
  REACT_APP_USER_POOL_DOMAIN,
} = process.env;

const awsmobile = {
  aws_project_region: REACT_APP_AWS_REGION,
  aws_cognito_identity_pool_id: REACT_APP_IDENTITY_POOL_ID,
  aws_cognito_region: REACT_APP_AWS_REGION,
  aws_user_pools_id: REACT_APP_USER_POOL_ID,
  aws_user_pools_web_client_id: REACT_APP_USER_POOL_CLIENT_ID,
  oauth: {
    domain: REACT_APP_USER_POOL_DOMAIN,
    client_id: REACT_APP_USER_POOL_CLIENT_ID,
    redirectSignIn: REACT_APP_CLOUDFRONT_DOMAIN,
    redirectSignOut: REACT_APP_CLOUDFRONT_DOMAIN,
    responseType: 'code',
    authority: `https://cognito-idp.us-west-2.amazonaws.com/${REACT_APP_USER_POOL_ID}`,
    scope: ['email', 'openid', 'phone', 'profile', 'aws.cognito.signin.user.admin'],
  },
  federationTarget: 'AMAZON_COGNITO_USER_POOLS',
  aws_cognito_mfa_configuration: 'OFF',
  aws_appsync_graphqlEndpoint: REACT_APP_APPSYNC_GRAPHQL_URL,
  aws_appsync_region: REACT_APP_AWS_REGION,
  aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
  graphql_headers: getIdToken,
};

export default awsmobile;
